import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Tooltip from 'flarum/common/components/Tooltip';
import ItemList from 'flarum/common/utils/ItemList';
import extractText from 'flarum/common/utils/extractText';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';

import ApplicationDownloadModal from './ApplicationDownloadModal';

function humanTime(time) {
    const d = dayjs(time);
    return d.fromNow();
}

export default class ApplicationListItem extends Component {
    oninit(vnode) {
        super.oninit(vnode);

        this.application = this.attrs.application;
    }

    oncreate(vnode) {
        super.oncreate(vnode);

        this.updateInterval = setInterval(m.redraw, 10000);
    }

    onremove(vnode) {
        super.onremove(vnode);

        clearInterval(this.updateInterval);
    }

    className() {
        return 'ApplicationListItem' + (this.is_suspended() ? ' Suspended' : (this.is_expired() ? ' Expired' : ''));
    }

    view() {
        return [
            <div className={this.className()} data-index={this.application.slug()}>
                {this.viewItems().toArray()}
            </div>,
            <hr />
        ];
    }

    is_suspended() {
        return this.application.suspendedAt() || this.application.status().application == 'frozen';
    }

    is_expired() {
        return dayjs().isAfter(dayjs(this.application.subscribedUntil()));
    }

    translate_until() {
        if (this.is_suspended())
            return 'xtreh-phoenix.forum.applications.suspended';
        else if (this.is_expired())
            return 'xtreh-phoenix.forum.applications.expired';

        return 'xtreh-phoenix.forum.applications.time_left';
    }

    viewItems() {
        const items = new ItemList();

        const application = this.application;

        const bannerUrl = app.forum.attribute('applicationsBaseUrl') + `/${application.slug()}/banner.png`;

        const disabled = this.is_suspended() || this.is_expired();

        items.add(
            'widget',
            <div className='Widget'>
                <span className='Banner'>
                    <img src={ bannerUrl }></img>
                </span>
                <span className='Label'>
                    <font>{ application.name() }</font>
                </span>
                <span className='Time' disabled={disabled}>
                    <Tooltip text={ dayjs(application.subscribedUntil()).format('LLL') } tooltipVisible={disabled ? false : undefined}>
                        <font>{ app.translator.trans(this.translate_until(), { left: humanTime(application.subscribedUntil()) }) }</font>
                    </Tooltip>
                </span>
            </div>,
            20
        );

        items.add(
            'controls',
            this.controlsView(this.controlItems().toArray()),
            10
        );

        return items;
    }

    controlItems() {
        const items = new ItemList();

        const application = this.application;

        const disabled = this.is_suspended() || this.is_expired();

        if (application.isConfigurable()) {
            items.add(
                'configure',
                {
                    label: app.translator.trans('xtreh-phoenix.forum.applications.control.configure'),
                    action: () => setRouteWithForcedRefresh(app.route('application.configs', { application: application.slug() })),
                    disabled: false
                },
                20
            );
        }

        if (application.isDownloadable()) {
            items.add(
                'download',
                {
                    label: app.translator.trans('xtreh-phoenix.forum.applications.control.download'),
                    action: () => app.modal.show(ApplicationDownloadModal, { application: application }),
                    disabled
                },
                10
            );
        }

        return items;
    }

    controlsView(controls) {
        return (
            <div className='Buttons-group'>
                { controls.map((control) => { return <a className='ApplicationButton' onclick={!control.disabled && control.action.bind(this)} disabled={control.disabled}>{control.label}</a> }) }
            </div>
        );
    }
}
